<template>
  <div
    :id="id"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Rechnung erstellen</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="closeModal"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12">
              <h4>Vorlage</h4>
            </div>
            <div clasS="col-12">
              <v-select
                v-model="vorlage"
                :options="vorlagen"
                label="bezeichnung"
                :clearable="false"
              >
              </v-select>
            </div>
            <div class="col-12 mt-3">
              <h4>Rechnungsstammdaten</h4>
            </div>
            <div class="col-4">
              <div class="form-group">
                <date-picker
                  :initial="rechnungsdatum"
                  @update="(val) => (rechnungsdatum = val)"
                  show-icon
                  date-format="dd.mm.yy"
                ></date-picker>
                <label>{{ $t("global.invoicedate") }}</label>
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <v-select
                  v-model="zahlungskondition"
                  label="bezeichnung"
                  :options="zahlungskonditionen"
                  placeholder="Zahlungskonditionen"
                  :clearable="false"
                >
                </v-select>
                <label>Zahlungskonditionen</label>
              </div>
            </div>
            <div class="col-12">
              <single-select-person
                id="kontaktperson"
                :person="kontaktperson"
                :label="$t('global.contactperson')"
                :rollen="filterMitarbeitende"
                :allowOpen="false"
                :editable="true"
                @confirmed="setKontaktperson"
              />
            </div>
            <div class="col-12">
              <div class="form-group">
                <input class="form-control" v-model.trim="unsereReferenz" />
                <label>Unsere Referenz</label>
              </div>
            </div>
            <div class="col-12">
              <div class="form-group">
                <textarea
                  rows="5"
                  class="form-control"
                  v-model.trim="einleitungstext"
                />
                <label>Einleitungstext</label>
              </div>
            </div>
            <div class="col-12">
              <div class="form-group">
                <textarea
                  rows="5"
                  class="form-control"
                  v-model.trim="schlusstext"
                />
                <label>{{ $t("global.closingtext") }}</label>
              </div>
            </div>
          </div>
          <verrechnungspositionen
            v-if="veranstaltung"
            :veranstaltung="veranstaltung"
            :shown="true"
            @vpGesetzt="setVerrechnungpositionIds"
          />
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeModal"
          >
            Abbrechen
          </button>
          <button
            type="button"
            class="btn btn-danger mr-2"
            @click="entfernen"
            v-if="remove"
          >
            {{ $t("global.remove") }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="rechnungErstellen"
            :disabled="VerrechnungspositionIds.length == 0"
          >
            Rechnung erstellen ({{ anmeldungen.length }})
          </button>
        </div>
      </div>
    </div>
        <messagebox-error
      :headerTitel="$t('global.createinvoice')"
      :errorText="$t('notification.failed')"
      id="error-rechnung-erstellen-alert-msgbox"
      @ok="closeModal"
    />
  </div>
</template>

<script>
import { modal } from "@/mixins/Modal";
import Api from "@/Api";
import DatePicker from "@/components/Datepicker";
import Verrechnungspositionen from "@/components/Rechnungslegung/Verrechnungspositionen.vue";
import SingleSelectPerson from "@/components/global/SingleSelectPerson.vue";
import { LADE_AUSWAHLWERTE_AUFTRAG } from "@/store/auftrag/actions.type";
import MessageboxError from "@/components/Modals/MessageboxError.vue";

import { textNotLinked } from "@/defaultTexts.js";

export default {
  components: { DatePicker, Verrechnungspositionen, SingleSelectPerson, MessageboxError },
  name: "RechnungErstellenModal",
  mixins: [modal],
  props: {
    anmeldungen: {
      type: Array,
      required: true,
      default: () => [],
    },
    veranstaltung: {
      type: String,
      required: false,
      default: null,
    },
    angemeldeterMitarbeiter: {
      type: Object,
      required: false,
    },
    remove: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      vorlage: null,
      vorlagen: [],
      rechnungsdatum: new Date().toGermanDateString(),
      kontaktperson: {},
      //kontaktpersonen: [],
      unsereReferenz: null,
      einleitungstext: null,
      zahlungskondition: {
        id: "17520A6C023",
        kuerzel: "30",
        bezeichnung: "30 Tage netto",
        sortierung: 20,
        tage: 30,
        standard: true,
      },
      schlusstext: null,
      VerrechnungspositionIds: [],
      filterMitarbeitende: this.$CONST("ROLLEN").MITARBEITER,
    };
  },
  watch: {
    vorlage(val) {
      this.einleitungstext = val.einleitungstext;
      this.schlusstext = val.schlusstext;
    },
    shown(val) {
      if (val && !this.kontaktperson?.id)
        this.kontaktperson = this.angemeldeterMitarbeiter.person;
      if (val && this.vorlagen.length == 0) {
        console.log("keine vorlagen");
        Api.get("rechnungslegung/vorlage/").then((response) => {
          this.vorlagen = response.data;
          this.vorlage = response.data.find((e) => e.standard) || null;
        });
      }
      if (val && this.zahlungskonditionen.length == 0) {
        this.$store.dispatch(`auftrag/${LADE_AUSWAHLWERTE_AUFTRAG}`);
      }
    },
  },
  created() {},
  mounted() {},
  computed: {
    zahlungskonditionen: {
      get() {
        return this.$store.state.auftrag.zahlungskonditionen;
      },
    },
  },
  methods: {
    setVerrechnungpositionIds(val) {
      this.VerrechnungspositionIds = val;
    },

    setKontaktperson(person) {
      //console.log("APIUSOD");
      //console.log("PERSON: " + person);
      this.kontaktperson = person;
    },

    /*
    searchKontaktperson(sucheString, loading) {
      if (sucheString) {
        loading(true);
        Api.get("geschaeftspartner/", {
          params: {
            suche: sucheString,
          },
        })
          .then((response) => {
            this.kontaktpersonen = response.data;
          })
          .finally(() => {
            loading(false);
          });
      }
    },
    kontaktpersonName(option) {
      if (typeof option === "string") {
        let person = this.kontaktpersonen.find((p) => p.id === option);
        if (person) return person.label;
        else "";
      } else {
        return option.personName;
      }
    },*/

    rechnungErstellen() {
      Api.post("rechnungslegung/veranstaltung/rechnung/", {
        anmeldungen: Array.from(new Set(this.anmeldungen)),
        vorlage: this.vorlage ? this.vorlage.id : null,
        zahlungskondition: this.zahlungskondition,
        rechnungsdatum: this.rechnungsdatum,
        kontaktperson: this.kontaktperson,
        veranstaltung: this.veranstaltung,
        unsereReferenz: this.unsereReferenz,
        einleitungstext: this.einleitungstext,
        schlusstext: this.schlusstext,
        verrechnungen: Array.from(new Set(this.VerrechnungspositionIds)),
      }).then((response) => {
        if (response.data.error.length != 0) {
          this.$bus.$emit("openMessageboxError", {
            data: response.data.error,
            id: "error-rechnung-erstellen-alert-msgbox",
          });
        } else {
          this.closeModal();
          this.$emit("changed");
        }
        /*
        this.$router.push({
          path: "/finanzen/auftraege",
        });
        */
      });
    },
    closeModal() {
      this.shown = false;
      $("#" + this.id).modal("hide");
    },
    entfernen() {},
  },
};
</script>

<style>
</style>
